<template>
    <v-card class="elevation-12" style="width:100%; min-height:300px;">
    <v-card-text style="width: 100%; height:100%;" class="ma-0 pa-0">
      <div v-if="loading" style="height:100%; width:100%; text-align: center;">
        <v-icon  x-large style="height:100%; font-size:150px;   margin: 0 auto;">mdi-chart-bar-stacked</v-icon>
      </div>
      <div v-else-if="transactions.length > 0">
        <h3 class="pl-5 pt-3">Подозрительные заправки </h3>
        <h6 class="pl-5 text--disabled">(Рабочее время - {{user.startWorkTime}} - {{user.endWorkTime}})</h6>
        <div class="chart-container ma-0 pa-0" style="width:100%; min-height:300px;">
          <!-- <canvas ref="canvas"></canvas> -->
          <Chart :chart-data="dataChart" :options="optionsChart"/>
        </div>
      </div>
      <div v-else style="height:100%; width:100%; text-align: center;">
        <v-row align="center" class="fill-height" justify="center" >
          <v-col>
            <h5>Нет данных</h5>
            <span class="text-subtitle-1">За выбранный период отсутсвутют данные. Проверьте токен данной системы ТК (для ППР) <router-link to="uploadReport">загрузите отчет</router-link> за выбранный период</span>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import Chart from './RateChart.js'
export default {
  computed: {
    ...mapState({
      user: state => state.users.user,
      transactions: state => state.transactions.transactions,
      noSuspectTransactions: state => state.transactions.noSuspectTransactions,
      suspectTransactions: state => state.transactions.suspectTransactions,
      loading: state => state.transactions.transactionsLoading
    }),
    startDate: function () {
      var sorted = this.dates.slice().sort(function (a, b) {
        return new Date(a) - new Date(b)
      })
      return sorted.shift()
    },
    endDate: function () {
      var sorted = this.dates.slice().sort(function (a, b) {
        return new Date(a) - new Date(b)
      })
      return sorted.pop()
    }
  },
  components: {
    Chart
  },
  data: () => ({
    dates: null,
    dataChart: {},
    optionsChart: {}
  }),
  watch: {
    transactions: function () {
      return this.UpdateChart()
    }
  },
  methods: {
    ...mapActions('transactions', {
      getTransactionsByDayAndStatus: 'getTransactionsByDayAndStatus'
    }),
    getUnquieDate () {
      if (this.transactions) {
        return [...new Set(
          this.transactions.map((str) => str.transactionDate.match(/^\d{4}-\d{2}-\d{2}/)[0])
        )]
      }
    },
    formatDate (date) {
      var dd = date.getDate()
      if (dd < 10) dd = '0' + dd

      var mm = date.getMonth() + 1
      if (mm < 10) mm = '0' + mm

      var yy = date.getFullYear() % 100
      if (yy < 10) yy = '0' + yy

      return dd + '.' + mm + '.' + yy
    },
    GetDataSets () {
      // eslint-disable-next-line eqeqeq
      if (this.suspectTransactions != undefined) {
        return [{
          name: 'noSuspect',
          label: 'Объем заправки (л.)',
          data: this.dates.map(d => {
            return this.noSuspectTransactions.reduce((total, t) => {
              // eslint-disable-next-line eqeqeq
              if (this.formatDate(new Date(t.transactionDate)) == this.formatDate(new Date(d))) {
                total += t.value
              }
              return total
            }, 0)
          }
          ),
          backgroundColor: 'rgba(0,51,153, 0.75)',
          borderColor: 'rgb(0,51,153,1)',
          borderWidth: 1
        },
        {
          name: 'Suspect',
          label: 'Подозрительные транзакции (л.)',
          data: this.dates.map(d => {
            return this.suspectTransactions.reduce((total, t) => {
              // eslint-disable-next-line eqeqeq
              if (this.formatDate(new Date(t.transactionDate)) == this.formatDate(new Date(d))) {
                total += t.value
              }
              return total
            }, 0)
          }
          ),
          backgroundColor: 'rgba(183,28,28, 0.75)',
          borderColor: 'rgba(183,28,28, 1)',
          borderWidth: 1
        }
        ]
      } else {
        return [{
          name: 'noSuspect',
          label: 'Объем заправки (л.)',
          data: this.dates.map(d => {
            return this.noSuspectTransactions.reduce((total, t) => {
              // eslint-disable-next-line eqeqeq
              if (this.formatDate(new Date(t.transactionDate)) == this.formatDate(new Date(d))) {
                total += t.value
              }
              return total
            }, 0)
          }
          ),
          backgroundColor: 'rgba(99, 99, 255, 0.7)',
          borderColor: 'rgba(0, 0, 255, 1)',
          borderWidth: 1
        }]
      }
    },
    getDayTransactions (date, suspect) {
      this.getTransactionsByDayAndStatus({ date: date, isSuspect: suspect })
    },
/* eslint-disable */
    UpdateChart () {
      var _this = this;
      var date, suspect
      if(this.transactions){
        this.dates = this.getUnquieDate()
        this.dataChart = {
            labels: this.dates,
            datasets: this.GetDataSets()
          }
        this.optionsChart = {
            responsive: true,
            legend: {
              labels:{
                fontColor: '#007bff'
              }
            },
            maintainAspectRatio : false,
            barValueSpacing: 1,
    scales: {
      xAxes: [{
        stacked: true,
        barPercentage: 1,
        categoryPercentage: 1,
        maxBarThickness: 25,
        ticks: {
          fontColor: '#007bff',
          callback: function(value) {
          return new Date(value).toLocaleDateString('ru-RU', {month:'short', day:'numeric'})
          }
        },
        type: 'time',
          time:{
            unit: 'week'
          },
        }],
      yAxes: [{ stacked: true, ticks:{
        fontColor: '#007bff',
        min: 0,
        minTicksLimit: 4,
        maxTicksLimit: 5,
      } }]
    },
    onClick: function(evt) {
      var activePoint = this.getElementAtEvent(evt)[0];
      if(activePoint){
      var data = activePoint._chart.data;
      var datasetIndex = activePoint._datasetIndex;
      var label = data.datasets[datasetIndex].label;
      var value = data.datasets[datasetIndex].data[activePoint._index];
      date = new Date(this.data.labels[activePoint._index])
      suspect = data.datasets[datasetIndex].name === 'Suspect'
      _this.getDayTransactions(date, suspect)
    }
      },
      plugins: {
	zoom: {
							pan: {
								enabled: true,
                mode: 'x', 
                threshold: 1,
                rangeMin: {
                  x: new Date(new Date(this.startDate).setDate(new Date(this.startDate).getDate() - 1)),
                  y: 0
                },
              rangeMax: {
                x: new Date(new Date(this.endDate).setDate(new Date(this.endDate).getDate() + 1)),
                y: 600
              }
							},
							zoom: {
								enabled: true,
								mode: 'x',
                sensitivity: 3,
                rangeMin: {
                  x: new Date(new Date(this.startDate).setDate(new Date(this.startDate).getDate() - 1)),
                  y: 0
                },
              rangeMax: {
                x: new Date(new Date(this.endDate).setDate(new Date(this.endDate).getDate() + 1)),
                y: 600
              }
							}
						}
}
  }
      }
    }
  },
    mounted () {
    this.UpdateChart()
  }
  /* eslint-enable */
}
</script>
